import { render, staticRenderFns } from "./StudyCenter.vue?vue&type=template&id=1cb84706"
import script from "./StudyCenter.vue?vue&type=script&lang=js"
export * from "./StudyCenter.vue?vue&type=script&lang=js"
import style0 from "./StudyCenter.vue?vue&type=style&index=0&id=1cb84706&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports